var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#F7F9FB"}},[_c('app-bar'),_c('left-menu'),_c('v-main',[_c('router-view')],1),_c('ag-notify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }